import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import CategoryBranch from './treeBranch';

import style from './style.css';

const initialState = {};

@observer
class BrandLine extends Component {
    render() {
        const { stores, brand, queryFilter, onClickBrand } = this.props;
        const isSelectedBrand = queryFilter.brand === brand.brandno;
        return (
            <div class='nav-item'>
                <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedBrand ? 'active' : ''}`}>
                    <span onClick={() => onClickBrand(brand.brandno)}>
                        {brand.name}
                        {brand.count && <span class='font-weight-lighter float-right'>({brand.count})</span>}
                    </span>
                </div>
                <div class={`d-${isSelectedBrand ? 'block' : 'none'} nav flex-column mt-1`}>
                    <CategoryBranch stores={stores} brand={brand.brandno} />
                </div>
            </div>
        );
    }
}

@observer
class BrandList extends Component {
    render() {
        const { stores, brands, queryFilter, onClickBrand } = this.props;
        return (
            <div>
                {brands.map(brand => <BrandLine stores={stores} brand={brand} queryFilter={queryFilter} onClickBrand={onClickBrand} />)}
            </div>
        );
    }
}

@observer
class CategoryTree extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };

        const { categoryStore, brandStore, productStore } = this.props.stores;
        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();

        categoryStore.toggleQueryfilter('brand', productStore.queryFilter.brand, { setValue: true, skipUpdate: true });
        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();
    }

    onClickBrand = (brandno) => {
        const { categoryStore, productStore } = this.props.stores;
        productStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
        productStore.toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
        productStore.toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('brand', brandno, { setValue: true });
        productStore.toggleQueryfilter('brand', brandno, { setValue: true });
    };

    render(props = this.props) {
        const { brandStore, productStore } = props.stores;
        const { brands } = brandStore;
        const { queryFilter } = productStore;

        return (
            <div class='nav flex-column nav-pills'>
                <BrandList stores={this.props.stores} brands={brands} queryFilter={queryFilter} onClickBrand={this.onClickBrand} />
            </div>
        );
    }
}

export default CategoryTree;



// WEBPACK FOOTER //
// ./components/products/tree.js